import { useArticleContractRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetArticleContractCommonInfoQuery } from "../../features/articles/articlesSlice";

export { useArticleContractRoutes };

export default GetDefaultIndex({ title: "قراردادهای مقالات", query: useGetArticleContractCommonInfoQuery });
